import { OPEN_BOOK_APPOINTMENT_MODAL } from "../../utils/constants";
import { isModalPopup } from "../../utils/variables";
import { openBookAppointment } from "./movePages";

export function bookAppointmentListeners() {

    const bookAppointmentContainer = document.querySelector('.bookAnAppointment__container');
    if(bookAppointmentContainer) {
        let cssProperties = {
            zIndex: isModalPopup ? 0 : 3,
            right: 0
        };
        Object.assign(bookAppointmentContainer.style, cssProperties);
    }

    if(isModalPopup) {
        let assistant = document?.querySelector('.assistant__iframe');
        if(assistant) assistant.style.opacity = 0;
    }
    const continueBtn = bookAppointmentContainer.querySelector('.bookAppointmentContinue__btn');
    if(continueBtn) {
        continueBtn.addEventListener('click', handleClickContinueBtn);
    }

    listenModalAppointmentFistPage();

}

function handleClickContinueBtn() {
    const bookAppointmentContainer = document.querySelector('.bookAnAppointment__container');
    if(!bookAppointmentContainer) return;
    let cssProperties = {
        zIndex: 0,
    };
    Object.assign(bookAppointmentContainer.style, cssProperties);
    openBookAppointment();
}

function listenModalAppointmentFistPage() {
    const bookAppointmentContainer = document.querySelector('.bookAppointmentFistScreen__container');
    const continueBtn = bookAppointmentContainer.querySelector('.bookAppointmentContinue__btn');
    if(continueBtn) {
        continueBtn.addEventListener('click', handleClickContinueBtnModal);
    }
}

function handleClickContinueBtnModal() {
    let assistant = document?.querySelector('.assistant__iframe');
    if(assistant) assistant.style.opacity = 1;

    parent.postMessage(OPEN_BOOK_APPOINTMENT_MODAL, '*');

}
